const steps = [
  {
    n: '01',
    title: 'Abra seu espaço',
    body: 'Cadastre a barbearia, unidades e serviços. Em minutos a operação já existe.',
  },
  {
    n: '02',
    title: 'Conecte o WhatsApp',
    body: 'Pareie a sessão, ative lembretes e deixe o bot agendar enquanto você corta.',
  },
  {
    n: '03',
    title: 'Coloque a equipe',
    body: 'Barbeiros entram pelo app. Agenda, ausência e comissão no bolso.',
  },
];

export default function HowItWorks() {
  return (
    <section id="como" className="border-y border-white/5 bg-ink-soft py-24 lg:py-28">
      <div className="mx-auto max-w-content px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <p className="text-sm font-medium tracking-wide text-copper">Como funciona</p>
            <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-bone sm:text-4xl text-balance">
              Três passos. Sem teatro.
            </h2>
          </div>

          <ol className="space-y-10 lg:col-span-7 lg:col-start-6">
            {steps.map((step) => (
              <li key={step.n} className="grid grid-cols-[auto_1fr] gap-5 border-t border-white/10 pt-8 first:border-0 first:pt-0">
                <span className="font-display text-sm font-semibold tabular-nums text-copper">{step.n}</span>
                <div>
                  <h3 className="font-display text-xl font-semibold text-bone">{step.title}</h3>
                  <p className="mt-2 max-w-md text-sm leading-relaxed text-mist sm:text-base">{step.body}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
